import "../css/Menu.css"

/*
The original file is in the back ups folder
*/

import { useState, useEffect } from "react";

 export const Menu = ({items}) => {

	const [demo_jsx, setDemoJSX] = useState(<></>);

	const handleMenuItemClick = (event) => {
		const s = button_texts_js[event.target.id];
		setDemoJSX(<span style={{fontWeight:'bold',color:'#9e2903'}}><u>{s}</u> button disabled for demo purposes!</span>)
	}
	useEffect(()=>{
		const timer = setTimeout(() => {
			setDemoJSX(<></>);
		  }, 2000);
		  return () => clearTimeout(timer);
	},[demo_jsx]);

	const button_texts_js = {
		selectAppPage: "Courses",
		appPage: "Activities",
		logOut: "Log out"
	}
	
	const createButton = (index, id) => {
		return (
			<button
				key={index}
				id={id}
				type="button"
				onClick={handleMenuItemClick}
				className="btn btn-light menu_item"
				style={{marginRight: 10}}
			>{button_texts_js[id]}</button>
		);
	}

	const items_a_jsx = items.map( (x,index) => {
		return createButton(index, x);
	});

	const jsx = (
		<div style={{padding:5, backgroundColor:'#C7E4FF'}}>
			<>{items_a_jsx}</>
			<>{demo_jsx}</>
		</div>
	);

	return jsx;
  };
  
  